import { ChangeDetectionStrategy,Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatHint, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
    templateUrl: './store-fulfiller-enable-log-dialog.component.html',
    styleUrls: ['./store-fulfiller-enable-log-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatFormField, MatLabel, MatInput, MatSuffix, MatHint, MatDialogActions, MatButton, MatDialogClose]
})
export class StoreFulfillerEnableLogDialogComponent {
    duration: number = 7;

}
